// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2YAqO","inputWrap":"styles_inputWrap__3nt8z","input":"styles_input__2KlJ6"};